export const getFileExtension = (path: string): string => {
  if (path === null || path.indexOf('.') === -1) {
    return '?'
  }

  return path.split('.').pop()
}

export const truncateFilename = (fileName: string, charLimit: number = 32): string => {
  const [ name ] = fileName && fileName.indexOf('.')
    ? fileName.split('.')
    : [fileName]

  return name.length > 30
    ? name.substr(0, charLimit) + '...'
    : name
}

export default {
  getFileExtension,
  truncateFilename,
}